import { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import { Loader2, Printer } from "lucide-react";
import { TicketQR } from "../components/site/TicketQR";
import { useAuth } from "../lib/auth";
import { api, apiError } from "../lib/api";
import { formatARS } from "../lib/site";
import { PAY } from "../components/traffic/CashPanel";

const Row = ({ k, v }) => <><dt className="text-[var(--muted-ink)]">{k}</dt><dd className="font-semibold">{v}</dd></>;

export default function AdminPasaje() {
  const { id } = useParams();
  const { user } = useAuth();
  const [b, setB] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { if (user) api.get(`/admin/bookings/${id}`).then((r) => setB(r.data)).catch((e) => setErr(apiError(e))); }, [user, id]);

  if (user === false) return <Navigate to="/admin" replace />;
  if (err) return <p data-testid="ticket-error" className="p-10 text-red-700">{err}</p>;
  if (!b) return <div className="grid min-h-[60vh] place-items-center"><Loader2 className="h-6 w-6 animate-spin" /></div>;

  return (
    <section data-testid="ticket-page" className="mx-auto max-w-md px-5 py-10 print:max-w-none print:p-0">
      <button onClick={() => window.print()} data-testid="ticket-print" className="mb-6 inline-flex items-center gap-2 rounded-full bg-[var(--forest)] px-5 py-2.5 text-sm font-bold text-white print:hidden"><Printer className="h-4 w-4" /> Imprimir pasaje</button>
      <div className="rounded-3xl border-2 border-dashed border-black/30 bg-white p-6 text-black">
        <img src="/brand/logo-green.png" alt="Santiagueño" className="h-10 w-auto" />
        <p className="mt-4 font-display text-2xl">{b.origin} → {b.destination}</p>
        <p className="text-sm">{b.from_stop} → {b.to_stop}</p>
        <dl className="mt-4 grid grid-cols-[auto_1fr] gap-x-4 gap-y-1 text-sm">
          <Row k="Fecha" v={b.date} /><Row k="Sale" v={`${b.departure} hs`} /><Row k="Butacas" v={b.seats.join(", ")} /><Row k="Servicio" v={b.service} />
          <Row k="Pasajero" v={b.name} /><Row k="DNI" v={b.dni} /><Row k="Total" v={formatARS(b.total)} />
          {b.payment && <Row k="Pago" v={PAY[b.payment] ?? b.payment} />}<Row k="Estado" v={b.status} />
        </dl>
        <div className="mt-5 flex flex-col items-center border-t border-dashed border-black/30 pt-5">
          <TicketQR code={b.code} size={170} />
          <p data-testid="ticket-code" className="mt-2 font-mono text-xl font-bold tracking-[0.2em]">{b.code}</p>
          <p className="mt-1 text-center text-xs">Mostrá este QR al conductor al subir. Emitido en {b.office || "web"}.</p>
        </div>
      </div>
    </section>
  );
}
